import { lazy } from 'react';
import Territories from './Territories';
import TerritoriesForm from './TerritoriesForm';

const TerritoriesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/territories',
      element: <Territories />,
    },
    {
      path: '/addTerritory',
      element: <TerritoriesForm />,
    },
    {
      path: '/editTerritory/:id',
      element: <TerritoriesForm />,
    },
  ],
};

export default TerritoriesConfig;
